import React, { useEffect, useState } from "react";
import axios from "axios";
import API_BASE_URL from "../apiConfig";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const EventosMasivos = () => {
  const [eventosMasivos, setEventosMasivos] = useState([]);
  const [eventoSeleccionado, setEventoSeleccionado] = useState("");
  const [telefono, setTelefono] = useState("");
  const [codigo, setCodigo] = useState("");
  const [codigoEnviado, setCodigoEnviado] = useState(false);
  const [cargando, setCargando] = useState(false);

  // // ✅ Obtener eventos masivos al cargar la pantalla
  // useEffect(() => {
  //   const fetchEventosMasivos = async () => {
  //     try {
  //       const response = await axios.get(`${API_BASE_URL}/Eventos/EventosMasivos`);
  //       setEventosMasivos(response.data);
  //     } catch (error) {
  //       console.error("Error al obtener eventos masivos:", error);
  //       toast.error("Error al obtener eventos masivos.");
  //     }
  //   };

  //   fetchEventosMasivos();
  // }, []);
  useEffect(() => {
    const fetchEventosMasivos = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/Eventos/EventosMasivos`);
  
        console.log("🟢 Datos recibidos del backend:", response.data);
  
        // 🔥 Filtrar solo eventos con estatus "Activo"
        const eventosActivos = response.data.filter(e =>
          e.estatusEvento?.toLowerCase().trim() === "activo"
        );

        console.log("// Eventos activos:", eventosActivos);
  
        setEventosMasivos(eventosActivos);
      } catch (error) {
        console.error("Error al obtener eventos masivos:", error);
        toast.error("Error al obtener eventos masivos.");
      }
    };
  
    fetchEventosMasivos();
  }, []);
  

  // ✅ Función para solicitar código de verificación
  const solicitarCodigo = async () => {
    if (!eventoSeleccionado) {
      toast.warning("Por favor, selecciona un evento.");
      return;
    }
    if (!telefono) {
      toast.warning("Por favor, ingresa tu número de teléfono.");
      return;
    }

    setCargando(true);
    try {
      const response = await axios.post(`${API_BASE_URL}/Eventos/SolicitarCodigo`, {
        Telefono: telefono
      });

      toast.success("Código enviado por WhatsApp.");
      setCodigoEnviado(true);
    } catch (error) {
      console.error("Error al solicitar código:", error);
      toast.error(error.response?.data?.message || "Error al solicitar código.");
    }
    setCargando(false);
  };

  // ✅ Función para validar el código ingresado y registrar la asistencia
  const validarCodigo = async () => {
    if (!codigo) {
      toast.warning("Por favor, ingresa el código de verificación.");
      return;
    }

    setCargando(true);
    try {
      const response = await axios.post(`${API_BASE_URL}/Eventos/ValidarCodigo`, {
        Telefono: telefono,
        Codigo: codigo,
        EventoId: eventoSeleccionado
      });

      toast.success("Asistencia registrada correctamente.");
      setCodigo(""); // Limpiar campo de código
      setTelefono("");
      setCodigoEnviado(false);
    } catch (error) {
      console.error("Error al validar código:", error);
      toast.error(error.response?.data?.message || "Código incorrecto. Inténtalo de nuevo.");
    }
    setCargando(false);
  };

  return (
    <div className="container mt-5 text-center">

      <img src="/img/monytorlogoa.png" alt="Imagen de login" className="login-image" />
      <h2 className="text-2xl font-bold mb-4">Eventos Masivos</h2>

      {/* 🔹 Select para elegir un evento masivo */}
      <label className="block text-lg mb-2">Selecciona un evento masivo:</label>
      <select
        className="w-1/2 p-2 border border-gray-300 rounded text-black"
        value={eventoSeleccionado}
        onChange={(e) => setEventoSeleccionado(e.target.value)}
      >
        <option value="">-- Seleccionar Evento --</option>
        {eventosMasivos.map((evento) => (
          <option key={evento.id} value={evento.id}>
            {evento.nombreEvento}
          </option>
        ))}
      </select>

      {/* 🔹 Formulario de teléfono */}
      {eventoSeleccionado && (
        <div className="mt-5">
          <label className="block text-lg mb-2">Ingresa tu número de teléfono:</label>
          <input
            type="text"
            className="w-1/2 p-2 border border-gray-300 rounded text-black"
            placeholder="Ejemplo: 81351585**"
            value={telefono}
            onChange={(e) => setTelefono(e.target.value)}
          />

          <button
            className={`mt-3 px-4 py-2 text-white rounded ${
              cargando ? "bg-gray-400 cursor-not-allowed" : "bg-blue-500 hover:bg-blue-600"
            }`}
            onClick={solicitarCodigo}
            disabled={cargando}
          >
            {cargando ? "Enviando..." : "Enviar Código"}
          </button>
        </div>
      )}

      {/* 🔹 Campo para ingresar código de verificación */}
      {codigoEnviado && (
        <div className="mt-5">
          <label className="block text-lg mb-2">Ingresa el código recibido por WhatsApp:</label>
          <input
            type="text"
            className="w-1/2 p-2 border border-gray-300 rounded text-black"
            placeholder="Ejemplo: 1234"
            value={codigo}
            onChange={(e) => setCodigo(e.target.value)}
          />

          <button
            className={`mt-3 px-4 py-2 text-white rounded ${
              cargando ? "bg-gray-400 cursor-not-allowed" : "bg-green-500 hover:bg-green-600"
            }`}
            onClick={validarCodigo}
            disabled={cargando}
          >
            {cargando ? "Verificando..." : "Validar Código"}
          </button>
        </div>
      )}
    </div>
  );
};

export default EventosMasivos;
